import styled from 'styled-components/macro';

import { StyledBox } from '../../../styles';

export const StyledDetailsBox = styled(StyledBox).attrs({ size: 'md', bg: 'primary' })`
    flex-grow: 1;
`;
